import { Icon } from '@livable/saas-react-components';
import { Button } from '@mui/material';
import React from 'react';
const getLabel = type => {
  switch (type) {
    case 'apple':
      return 'Apple ID';
    case 'google':
      return 'Google';
    case 'facebook':
      return 'Facebook';
    case 'twitter':
      return 'Twitter';
    case 'linkedin':
      return 'Linkedin';
    case 'microsoft':
      return 'Microsoft';
    default:
      return type;
  }
};
const SocialButton = _ref => {
  let disabled = _ref.disabled,
    type = _ref.type;
  return /*#__PURE__*/React.createElement(Button, {
    variant: "social",
    social: type,
    disabled: disabled
  }, /*#__PURE__*/React.createElement(Icon, {
    type: type
  }), getLabel(type));
};
export default SocialButton;